export default "__VITE_ASSET__DSg5IJOh__"